import { makeObservable, action } from "mobx";
import { Auth } from '../api';

export default class WebAuthnStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      preformatGetAssertReq: action,
      publicKeyCredentialToJSON: action,
      encode: action,
      decode: action,
      preformatMakeCredReq: action,
      addWebauthn: action
    });
  }

  async preformatGetAssertReq(getAssert) {
    try {
      getAssert.challenge = await this.decode(getAssert.challenge);

      for (let allowCred of getAssert.allowCredentials) {
        allowCred.id = await this.decode(allowCred.id);
      }

      return getAssert;
    } catch (error) {
      console.error("Error in preformatGetAssertReq:", error);
      throw error;
    }
  }

  async publicKeyCredentialToJSON(pubKeyCred) {
    try {
      if (pubKeyCred instanceof Array) {
        let arr = [];
        for (let i of pubKeyCred)
          arr.push(await this.publicKeyCredentialToJSON(i));

        return arr;
      }

      if (pubKeyCred instanceof ArrayBuffer) {
        return await this.encode(pubKeyCred);
      }

      if (pubKeyCred instanceof Object) {
        let obj = {};

        for (let key in pubKeyCred) {
          obj[key] = await this.publicKeyCredentialToJSON(pubKeyCred[key]);
        }

        return obj;
      }

      return pubKeyCred;
    } catch (error) {
      console.error("Error in publicKeyCredentialToJSON:", error);
      throw error;
    }
  }

  async encode(arraybuffer) {
    try {
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

      let lookup = new Uint8Array(256);
      for (let i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
      }

      let bytes = new Uint8Array(arraybuffer),
        i, len = bytes.length, base64url = '';

      for (i = 0; i < len; i += 3) {
        base64url += chars[bytes[i] >> 2];
        base64url += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64url += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64url += chars[bytes[i + 2] & 63];
      }

      if ((len % 3) === 2) {
        base64url = base64url.substring(0, base64url.length - 1);
      } else if (len % 3 === 1) {
        base64url = base64url.substring(0, base64url.length - 2);
      }

      return base64url;
    } catch (error) {
      console.error("Error in encode:", error);
      throw error;
    }
  }

  async decode(base64string) {
    try {
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

      let lookup = new Uint8Array(256);
      for (let i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
      }

      let bufferLength = base64string.length * 0.75,
        len = base64string.length, i, p = 0,
        encoded1, encoded2, encoded3, encoded4;

      let bytes = new Uint8Array(bufferLength);

      for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64string.charCodeAt(i)];
        encoded2 = lookup[base64string.charCodeAt(i + 1)];
        encoded3 = lookup[base64string.charCodeAt(i + 2)];
        encoded4 = lookup[base64string.charCodeAt(i + 3)];

        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
      }

      return bytes.buffer;
    } catch (error) {
      console.error("Error in decode:", error);
      throw error;
    }
  }

  async preformatMakeCredReq(makeCredReq) {
    try {
      makeCredReq.challenge = await this.decode(makeCredReq.challenge);
      makeCredReq.user.id = await this.decode(makeCredReq.user.id);
      return makeCredReq;
    } catch (error) {
      console.error("Error in preformatMakeCredReq:", error);
      throw error;
    }
  }

  async addWebauthn() {
    try {
      let retObj = await Auth.addPublicKey(this.rootStore.authStore.user._id);
      if (retObj.data === 'error') {
        return retObj.data;
      }

      let challengeMakeCred = retObj.data;
      let publicKey = await this.preformatMakeCredReq(challengeMakeCred);

      let nav = await navigator.credentials.create({ publicKey }).catch((error) => {
        console.error("navigator.credentials.create error:", error);
        return false;
      });

      if (!nav) {
        return false;
      }

      let makeCredResponse = await this.publicKeyCredentialToJSON(nav);
      if (!makeCredResponse.rawId || !makeCredResponse.type || !makeCredResponse.id || makeCredResponse.type !== "public-key") {
        return false;
      }

      let args = {
        challenge: makeCredResponse,
        Device: navigator.userAgentData
      };

      retObj = await Auth.saveWebAuthn(this.rootStore.authStore.user._id, args);
      if (!retObj.data.success) {
        return false;
      }

      this.rootStore.authStore.user = retObj.data.user;
      return true;

    } catch (error) {
      console.error("Error in addWebauthn:", error);
      return false;
    }
  }
}
